import React from 'react'
import { parent } from 'glamor'
import { navigate } from 'gatsby'
import {
  FaFacebookF,
  FaSpotify,
  FaInstagram,
  FaBloggerB,
  FaYoutube,
  FaAngleDown,
  FaAngleUp,
} from 'react-icons/fa'
import { IoIosMenu } from 'react-icons/io'

// Import typefaces
import 'typeface-montserrat'
import 'typeface-merriweather'

// App components
import CustomLink from '../components/CustomLink'

// App content
import logo from '../assets/logo.png'
import logoWhite from '../assets/logo-white.png'
import requestAppointment from '../assets/ScheduleFREEConsultation_Button_NavBar.png'
import tiktok from '../assets/social/tiktok.png'

// App utils
import config from '../utils/config'
import { rhythm } from '../utils/typography'
import { themeStyles, colors, presets } from '../utils/theme'

const menuConfig = [
  {
    title: 'Orthodontics',
    subMenus: [
      {
        title: 'Braces',
        link: '/orthodontics/braces',
      },
      {
        title: 'Invisalign',
        link: '/orthodontics/invisalign',
      },
      {
        title: 'Cost of Braces and Invisalign',
        link: '/orthodontics/cost-of-braces-and-invisalign',
      },
      {
        title: 'When Should You See an Orthodontist',
        link: '/orthodontics/when-should-you-see-an-orthodontist',
      },
      {
        title: 'Retainers',
        link: '/orthodontics/retainers',
      },
    ],
  },
  {
    title: 'Why Collins',
    subMenus: [
      {
        title: 'Meet Dr. Collins',
        link: '/why-collins/meet-dr-collins',
      },
      {
        title: 'Our Team',
        link: '/why-collins/our-team',
      },
      {
        title: 'See Our Work',
        link: '/why-collins/see-our-work',
      },
      {
        title: 'Patient Experiences',
        link: '/why-collins/patient-experiences',
      },
    ],
  },
  {
    title: 'The Next Step',
    subMenus: [
      {
        title: 'Schedule a Free Consult',
        link: '/the-next-step/schedule-a-free-consult',
      },
      {
        title: 'New Patient Forms',
        link: '/the-next-step/new-patient-forms',
      },
      // {
      //   title: 'Virtual Visit',
      //   link: '/the-next-step/virtual-consultation',
      // },
      {
        title: 'Refer a Friend',
        link: '/the-next-step/refer-a-friend',
      },
      {
        title: 'Common Questions',
        link: '/the-next-step/common-questions',
      },
    ],
  },
  {
    title: 'Resources',
    subMenus: [
      {
        title: 'Free Reports and Articles',
        link: '/resources/free-reports-and-articles',
      },
      {
        title: 'Books',
        link: '/resources/books',
      },
      {
        title: 'Eating with Braces',
        link: '/resources/eating-with-braces',
      },
      {
        title: 'Troubleshooting Your Braces',
        link: '/resources/troubleshooting-your-braces',
      },
      {
        title: 'Collins Blog',
        link: '/resources/collins-blog',
      },
    ],
  },
  {
    title: 'Contact Us',
    subMenus: [
      {
        title: 'Map and Directions',
        link: '/contact-us/map-and-directions',
      },
      {
        title: 'Orthodontic Referral',
        link: '/contact-us/orthodontic-referral',
      },
      {
        title: 'Careers at Collins',
        link: '/contact-us/careers-at-collins',
      },
      {
        title: 'Adopt-A-Shark',
        link: '/contact-us/adopt-a-shark',
      },
      {
        title: 'The Donut',
        link: '/the-donut/',
      },
      {
        title: 'Merchandise',
        href: 'https://shopcollinsortho.com/collections/all?sort_by=price-ascending#MainContent',
      },
      {
        title: 'COVID-19 Update',
        link: '/contact-us/covid-19-update',
      },
    ],
  },
]

const styles = {
  dropdown: {
    position: 'relative',
    display: 'inline-block',
    cursor: 'pointer',
    alignSelf: 'stretch',
    display: 'none',
    [presets.Tablet]: {
      display: 'block',
    },
  },
  titleContainer: {
    display: 'flex',
    flex: 1,
    height: '100%',
    alignSelf: 'stretch',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: rhythm(1 / 2),
    [presets.Desktop]: {
      fontSize: rhythm(5 / 8),
    },
    [presets.Hd]: {
      fontSize: rhythm(3 / 4),
    },
  },
  dropdownContent: {
    position: 'absolute',
    backgroundColor: 'rgba(0,0,0,0.6)',
    left: '-50px',
    top: '40px',
    minWidth: '200px',
    zIndex: 1,
    display: 'none',
    ':hover': {
      display: 'block',
    },
    [presets.Desktop]: {
      top: '40px',
    },
    [presets.Hd]: {
      top: '60px',
    },
  },
  dropdownLink: {
    color: 'black',
    textAlign: 'center',
    padding: '12px 16px',
    textDecoration: 'none',
    display: 'block',
    color: 'white',
    ':hover': {
      backgroundColor: 'black',
    },
  },
  mobileMenuContainer: {
    display: 'block',
    [presets.Tablet]: {
      display: 'none',
    },
  },
  logo: {
    marginRight: rhythm(1 / 2),
    marginBottom: 0,
    height: rhythm(3),
    minWidth: '100px',
    [presets.Mobile]: {
      height: rhythm(4),
      minWidth: '150px',
    },
    [presets.Desktop]: {
      height: rhythm(5),
      minWidth: '200px',
    },
  },
  requestAppointment: {
    marginRight: 0,
    marginBottom: 0,
    marginTop: '10px',
    height: rhythm(3 / 2),
    minWidth: '100px',
    [presets.Mobile]: {
      marginRight: rhythm(1 / 2),
      height: rhythm(2),
      minWidth: '120px',
    },
    [presets.Desktop]: {
      marginTop: '20px',
      height: rhythm(3),
      minWidth: '160px',
    },
  },
  mobileMenuText: {
    fontSize: rhythm(5 / 8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    cursor: 'pointer',
  },
  mobileMenuFullScreen: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
    backgroundColor: 'rgba(0,0,0,.9)',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  mobileMenuCategory: {
    color: colors.brightBlue,
    fontSize: '4vh',
    cursor: 'pointer',
    width: '80%',
    margin: '0 auto',
    marginTop: '1vh',
  },
  mobileSubmenuItem: {
    color: 'white',
    fontSize: '3vh',
    padding: '1vh',
    fontWeight: 100,
  },
  theDonutBox: {
    outline: '2px #fff solid',
    color: '#fff',
    marginLeft: '20px',
    padding: '10px',
    fontWeight: 'bold',
    borderRadius: '8px',
  },
  theDonutBoxLink: {
    textDecoration: 'none',
    color: '#fff !important',
    letterSpacing: '1px',
  },
  phoneNumber: {
    color: '#fff',
    marginRight: rhythm(1 / 2),
    fontSize: rhythm(3 / 4),
    textDecoration: 'none',
  },
  socialHolder: {
    padding: '10px 20px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    [presets.Mobile]: {
      padding: '10px 40px',
      justifyContent: 'flex-end',
      ...themeStyles.contentWidth,
    },
  },
}

const MobileMenuItem = ({
  isOpen,
  menuConfig,
  onToggleSubmenu,
  onToggleMenu,
}) => {
  const arrowIcon = isOpen ? (
    <FaAngleUp style={{ marginRight: rhythm(1 / 2) }} />
  ) : (
    <FaAngleDown style={{ marginRight: rhythm(1 / 2) }} />
  )
  return (
    <div css={styles.mobileMenuCategory} key={menuConfig.title}>
      <div
        css={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
        onClick={onToggleSubmenu}
      >
        {arrowIcon} {menuConfig.title}
      </div>
      <div css={{ display: 'flex', flexDirection: 'column' }}>
        {isOpen &&
          menuConfig.subMenus.map((item) => (
            <div
              key={item.title}
              role="link"
              css={styles.mobileSubmenuItem}
              to={item.link}
              onClick={() => onToggleMenu(item.link)}
            >
              {item.title}
            </div>
          ))}
      </div>
    </div>
  )
}

const MobileMenu = ({
  menuConfig,
  isOpen,
  onToggleMenu,
  onToggleSubmenu,
  currentOpenSubmenu,
}) => {
  const menus = menuConfig.map((config) => (
    <MobileMenuItem
      key={config.title}
      isOpen={currentOpenSubmenu === config.title}
      menuConfig={config}
      onToggleMenu={onToggleMenu}
      onToggleSubmenu={() => onToggleSubmenu(config.title)}
    />
  ))

  return (
    <div css={styles.mobileMenuContainer}>
      <div css={styles.mobileMenuText} onClick={onToggleMenu}>
        <IoIosMenu size="25" /> MENU
      </div>
      {isOpen && (
        <div css={styles.mobileMenuFullScreen}>
          <div
            role="link"
            css={{ margin: '0 auto' }}
            onClick={() => onToggleMenu('/')}
          >
            <img
              src={logoWhite}
              alt={`Collins Orthodontics`}
              css={{ maxWidth: '15vh', marginTop: '3vh' }}
            />
          </div>
          <div>{menus}</div>
        </div>
      )}
    </div>
  )
}

const MenuItem = ({ title, subMenus = [] }) => {
  const subMenuLinks = subMenus.map((item) => {
    if (item.link) {
      return (
        <CustomLink key={item.title} css={styles.dropdownLink} to={item.link}>
          {item.title}
        </CustomLink>
      )
    }
    return (
      <CustomLink key={item.title} href={item.href} css={styles.dropdownLink}>
        {item.title}
      </CustomLink>
    )
  })
  return (
    <div key={title} css={styles.dropdown}>
      <div css={styles.titleContainer}>{title.toUpperCase()}</div>
      <div
        css={[
          styles.dropdownContent,
          parent('div:hover >', { display: 'block' }),
        ]}
      >
        {subMenuLinks}
      </div>
    </div>
  )
}

const SocialBar = () => {
  const iconStyle = { marginLeft: '15px' }
  const linkStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
  return (
    <div
      id="cw-main-nav-social-media"
      css={{ width: '100%', backgroundColor: 'black' }}
    >
      <div css={styles.socialHolder}>
        <CustomLink
          css={styles.phoneNumber}
          target="_blank"
          href="tel:15072585400"
        >
          (507) 258-5400
        </CustomLink>
        <div css={{ display: 'flex', flexDirection: 'row' }}>
          <CustomLink
            css={linkStyle}
            target="_blank"
            href={config.socialLinks.tiktok}
          >
            <img src={tiktok} css={{ margin: 0, width: 20, ...iconStyle }} />
          </CustomLink>
          <CustomLink
            css={linkStyle}
            target="_blank"
            href={config.socialLinks.instagram}
          >
            <FaInstagram color="white" size="15" css={iconStyle} />
          </CustomLink>
          <CustomLink
            css={linkStyle}
            target="_blank"
            href={config.socialLinks.youtube}
          >
            <FaYoutube color="white" size="20" css={iconStyle} />
          </CustomLink>
          <CustomLink
            css={linkStyle}
            target="_blank"
            href={config.socialLinks.facebook}
          >
            <FaFacebookF color="white" size="15" css={iconStyle} />
          </CustomLink>
          <CustomLink
            css={linkStyle}
            target="_blank"
            href={config.socialLinks.spotify}
          >
            <FaSpotify color="white" size="15" css={iconStyle} />
          </CustomLink>
          <CustomLink
            css={linkStyle}
            target="_blank"
            href={config.socialLinks.blogger}
          >
            <FaBloggerB color="white" size="15" css={iconStyle} />
          </CustomLink>
          <div css={styles.theDonutBox}>
            <CustomLink
              css={styles.theDonutBoxLink}
              target="_blank"
              href="https://rochesterorthodontics.com/the-donut/"
            >
              The Donut
            </CustomLink>
          </div>
        </div>
      </div>
    </div>
  )
}

class Header extends React.Component {
  state = {
    isMenuOpen: false,
    currentOpenSubmenu: 'Orthodontics',
  }

  toggleMenu = (pagePath) => {
    if (typeof pagePath == 'string') {
      navigate(pagePath)
    }
    this.setState({ isMenuOpen: !this.state.isMenuOpen })
  }

  toggleSubmenu = (title) => {
    this.setState({
      currentOpenSubmenu:
        this.state.currentOpenSubmenu === title ? null : title,
    })
  }

  render() {
    const menus = this.props.menuConfig.map((config) => (
      <MenuItem
        key={config.title}
        title={config.title}
        subMenus={config.subMenus}
      />
    ))
    return (
      <div
        id="collins-website-main-nav"
        css={{ zIndex: 100, backgroundColor: 'rgba(256,256,256,.7)' }}
      >
        {!this.props.hideSocial && <SocialBar />}
        <div
          id="cw-main-nav-wrapper"
          css={{
            display: 'flex',
            alignSelf: 'stretch',
            marginBottom: rhythm(2.5),
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: rhythm(1 / 2),
            zIndex: 100,
            ...themeStyles.contentWidth,
          }}
        >
          <CustomLink to="/">
            <img src={logo} alt={`Collins Orthodontics`} css={styles.logo} />
          </CustomLink>
          <div
            css={{
              zIndex: 1000,
              display: 'flex',
              flex: 1,
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div />
            <MobileMenu
              currentOpenSubmenu={this.state.currentOpenSubmenu}
              menuConfig={menuConfig}
              isOpen={this.state.isMenuOpen}
              onToggleMenu={this.toggleMenu}
              onToggleSubmenu={this.toggleSubmenu}
            />
            {menus}
            {!this.props.hideRequestAppointment && (
              <CustomLink to="/the-next-step/schedule-a-free-consult">
                <img
                  src={requestAppointment}
                  alt={`Request Appointment`}
                  css={styles.requestAppointment}
                />
              </CustomLink>
            )}
          </div>
        </div>
      </div>
    )
  }
}

Header.defaultProps = {
  menuConfig,
}

export default Header
